import React from 'react';
import { SearchIcon } from './icons/IconProvider';
const SearchInput = ({
  placeholder = 'Search...',
  name = 'search',
  value,
  onChange,
  className = '',
}) => {
  return (
    <div className={`relative inline-flex w-full ${className}`}>
      <input
        className="pr-10 h-[42px] border border-gray-200 w-full"
        placeholder={placeholder}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
      />
      <SearchIcon />
    </div>
  );
};

export default SearchInput;
